import { Box, InputBase, List, useTheme,ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useState, useEffect } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import { themeSettings, tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { useGetRelationInvoiceProductsQuery } from "../../../newapi/global/relation/relationSlice";
import { useAddInvoiceInvoiceProductsMutation } from "../../../newapi/financial/invoiceSlice";
import { showToastMessagePostRequest, showToastMessage, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import { InputDropdown } from "../../theme/dropdowns/InputDropdown";
import { yupRequired } from "../../../utils/validation";
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from "@mui/material";
import { EuroOutlined } from "@mui/icons-material";
import NumberInput from "../../theme/inputs/NumberInput";

const MAddInvoiceLine = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [selected, setSelected] = useState(-1);

    const { data: relationProducts, productsLoading } = useGetRelationInvoiceProductsQuery({id: props.relationId, onlyActive: true, ...(props.subType ? {subType: props.subType} : {})});

    const [fieldErrors, setFieldErrors] = useState({});
    const [newInvoiceLines, setNewInvoiceLines] = useState([{
        id: 0,
        rowIndex: 0,
        amount: 0,
        description: ""
    }]);

    const handleClose = () => {
        setNewInvoiceLines([{
            id: 0,
            rowIndex: 0,
            amount: 0,
            description: ""
        }]);
        props.handleClose();
    }

    const validateLines = () => {
        const withoutAmount = newInvoiceLines.filter(x => x.id > 0 && (!x.amount || isNaN(x.amount) || parseFloat(x.amount) === 0)).map(x => x.rowIndex + 1);
        const withoutPrice = newInvoiceLines.filter(x => x.id > 0 && (!x.manualPrice || isNaN(x.manualPrice) || parseFloat(x.manualPrice) === 0)).map(x => x.rowIndex + 1);
        const withoutDescription = newInvoiceLines.filter(x => x.id > 0 && (!x.description || x.description.length === 0)).map(x => x.rowIndex + 1);

        let errors = "";
        if (withoutPrice.length > 0) {
            errors = `${t('invoiceline_err_price')}: ${withoutPrice.join(", ")}`;
        }
        if (withoutAmount.length > 0) {
            errors += `${errors.length ? ", " : ""}${t('invoiceline_err_amount')}: ${withoutAmount.join(", ")}`;
        }
        if (withoutDescription.length > 0) {
            errors += `${errors.length ? ", " : ""}${t('invoiceline_err_description')}: ${withoutDescription.join(", ")}`;
        }

        return errors;
    }

    const [addInvoiceProducts, {isLoading}] = useAddInvoiceInvoiceProductsMutation();
    const SaveInvoiceProducts = async (newInvoiceLines, props) => {
        try {
            if (isLoading) return;

            const errmsg = validateLines();
            if (errmsg.length > 0) {
                showToastMessage("error", errmsg);
                return;
            }

            const incompleteLine = newInvoiceLines.find(line => line.id > 0 && line.amount === 0);
            if (incompleteLine) {
                showToastMessage("error", `${t("incomplete_line")} - ${incompleteLine.name}`);
                return;
            }

            const mappedProducts = newInvoiceLines
            .filter(line => line.id > 0 && line.manualPrice && line.manualPrice !== 0 && line.description && line.description.length > 0)
            .map(line => ({
                relationInvoiceProductId: line.id,
                amount: line.amount,
                description: line.description,
                manualPrice: line.manualPrice,
                ...(props.linkedObject ? {linkedId: props.linkedObject.id} : {}),
                ...(props.linkedObject ? {linkedType: props.linkedObject.type} : {})
            }));

            const requestData = {
                invoiceId: props.invoiceId,
                relationId: props.relationId,
                invoiceProducts: mappedProducts
            }
            
            const data = await addInvoiceProducts(requestData).unwrap()
            showToastMessagePostRequest(t, data);
            handleClose();
        } catch (err) {
            // Handle other errors, such as network errors
            showToastMessageRequestError(t("create_failed"), t, err);
        }
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleProductSelect = (rowIndex, selected) => {
        rowIndex = parseInt(rowIndex);
        // Check if selected product is already in the list
        const isDuplicate = newInvoiceLines.some(line => line.id === selected.id);
        if (isDuplicate) {
            showToastMessage("error", t("product_already_in_list"));
            return;
        }

        // Check if last item has id = 0
        setNewInvoiceLines(prev => prev.map((line, index) => {
            if (line.rowIndex === rowIndex) {
                return {
                    rowIndex: rowIndex,
                    amount: 0,
                    description: selected.name,
                    manualPrice: selected.isCustomPrice ? selected.price : selected.categoryProduct.price,
                    ...selected
                };
            }
            return line;
        }));
    };

    useEffect(() => {
        const lastItem = newInvoiceLines[newInvoiceLines.length - 1];
        if (lastItem.id > 0) {
            setNewInvoiceLines(prev => [...prev, {
                id: 0,
                rowIndex: newInvoiceLines.length
            }]);
        }
    }, [newInvoiceLines]);

    const handleDeleleteLineRow = (rowIndex) => {
        setNewInvoiceLines(prev => prev.filter(line => line.rowIndex !== rowIndex));
    };

    const handleChange = (rowIndex, key, value) => {
        setNewInvoiceLines(prev => prev.map((line, index) => {
            if (line.rowIndex === rowIndex) {
                return {
                    ...line,
                    [key]: value
                };
            }
            return line;
        }));
    };
      

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("add_invoice_lines")}</Subheading>
            </Box>

            {/* BODY */}
                {newInvoiceLines && newInvoiceLines.length > 0 && newInvoiceLines.map((invoiceLine, index) => (
                    <Box key={"add-invoice-line-"+index}
                        sx={{
                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                            paddingRight:3,
                            paddingLeft:3,
                            paddingTop:1,
                            paddingBottom:1,
                            borderTopLeftRadius:16,
                            borderTopRightRadius:16,
                            display:"flex",
                            alignItems:"center",
                            gap:1
                        }}
                    >
                        <Box
                            sx={{
                                flex:1,
                                "@media screen and (max-width: 47.9375em)" : {
                                    flex:1
                                }
                            }}
                        >
                            <Box lineHeight={"40px"} width={"104px"}>
                                <Text>{t("invoice_product")}</Text>
                            </Box>
                            
                            <Box display="flex"
                                height="40px"
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                                <InputDropdown
                                    searchOptions={{
                                        enabled: true,
                                        placeholder: t("search")
                                    }}
                                    styles={{
                                        minWidth:300
                                    }}
                                    displayName={"name"} 
                                    onChange={(selected) => handleProductSelect(index, relationProducts[selected])}
                                    noSelection={t("choose_option")}
                                    options={relationProducts ?? []}
                                    closeOnSelection
                                />
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                flex:1,
                                "@media screen and (max-width: 47.9375em)" : {
                                    flex:1
                                }
                            }}
                        >
                            <Box lineHeight={"40px"} width={"104px"}>
                                <Text>{t("description")}</Text>
                            </Box>
                            
                            <Box display="flex"
                                height="40px"
                                // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[100]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                            <InputBase 
                                    sx={{
                                        px:2,
                                        flex:1, 
                                        color:colors.txt["primary"],
                                        lineHeight:"32px",
                                    }}
                                    value={invoiceLine.description}
                                    onChange={(e) => handleChange(index, 'description', e.target.value)}
                                    disabled={invoiceLine.id === 0}
                                />  
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                flex:1,
                                "@media screen and (max-width: 47.9375em)" : {
                                    flex:1
                                }
                            }}
                        >
                            <Box lineHeight={"40px"} width={"104px"}>
                                <Text>{t("amount")}</Text>
                            </Box>
                            
                            <Box display="flex"
                                height="40px"
                                // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[100]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                            <InputBase 
                                    sx={{
                                        px:2,
                                        flex:1, 
                                        color:colors.txt["primary"],
                                        lineHeight:"32px",
                                    }}
                                    type="number"
                                    value={invoiceLine.amount}
                                    onChange={(e) => handleChange(index, 'amount', e.target.value)}
                                    disabled={invoiceLine.id === 0}
                                />  
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                flex:1,
                                "@media screen and (max-width: 47.9375em)" : {
                                    flex:1
                                }
                            }}
                        >
                            <Box lineHeight={"40px"} width={"104px"}>
                                <Text>{t("price")}</Text>
                            </Box>
                            
                            <Box 
                            
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    background:colors.grey[100],
                                    borderRadius:5,
                                    height:40,
                                    flex:1,
                                    pl:0.5,
                                }}
                            >
                            
                                <Box
                                    sx={{
                                        background: themeSettings(theme.palette.mode).palette.primaryGrey.main,
                                        color:themeSettings(theme.palette.mode).palette.primaryGrey.contrastText,
                                        height:32,
                                        width:32,
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        borderRadius:4,
                                    }}
                                >
                                    <EuroOutlined fontSize="small"/>
                                </Box>
                            <InputBase 
                                    sx={{
                                        px:2,
                                        flex:1, 
                                        color:colors.txt["primary"],
                                        lineHeight:"32px",
                                    }}
                                    type="number"
                                    value={invoiceLine.manualPrice}
                                    onChange={(e) => handleChange(index, 'manualPrice', e.target.value)}
                                    disabled={invoiceLine.id === 0}
                                />  
                                
                            </Box>
                        </Box>
                        { index > 0 ?

                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    }
                                }}
                            >
                                <Box lineHeight={"40px"} width={40}>
                                    <Text>&nbsp;</Text>
                                </Box>

                                <Box display="flex"
                                    height="40px"
                                    // maxWidth="400px"
                                    borderRadius="20px"
                                    
                                    sx={{
                                        
                                    }}
                                >
                                    <IconButton color="red" type="button" onClick={() => handleDeleleteLineRow(index)} sx={{p:1}}>
                                        <DeleteIcon/>
                                    </IconButton>
                                </Box>
                            </Box>
                            // <Box
                            //     sx={{
                            //         display:"flex",
                            //         alignItems:"center",
                            //         width:40

                            //     }}
                            // >
                            //     <IconButton type="button" onClick={() => handleDeleleteLineRow(index)} sx={{p:1}}>
                            //         <DeleteIcon/>
                            //     </IconButton>
                            // </Box>
                        : 
                        newInvoiceLines.length > 0 ?
                            <Box
                                sx={{
                                    width:40,
                                }}
                            >

                            </Box>
                            : null
                        }
                    </Box>
                ))}
            <Box
                component="footer"
                sx={{
                    pt:2,
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    // paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}> 
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveInvoiceProducts(newInvoiceLines, props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddInvoiceLine;
